import { useState, useEffect } from "react";
import { Clock } from "lucide-react";

const LiveClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timer = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const omskTime = new Intl.DateTimeFormat('ru-RU', {
    timeZone: 'Asia/Omsk',
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
    hour12: false
  }).format(time);

  const isWorkingHours = () => {
    const hour = parseInt(omskTime.split(':')[0]);
    const day = time.getDay();
    
    if (day >= 1 && day <= 5) {
      return hour >= 10 && hour < 20;
    } else if (day === 6 || day === 0) {
      return hour >= 12 && hour < 18;
    }
    return false;
  };

  const working = isWorkingHours();

  return (
    <div className="cyber-card p-6 bg-background/50">
      <div className="flex items-center justify-between mb-4">
        <p className="text-secondary font-mono text-sm font-bold">{'>> ВРЕМЯ_ОМСК'}</p>
        <Clock className={`w-5 h-5 ${working ? 'text-primary animate-pulse' : 'text-muted-foreground'}`} />
      </div>
      
      <div className="text-center space-y-4">
        <div className="font-terminal text-4xl tracking-wider">
          <span className={working ? 'text-primary' : 'text-muted-foreground'}>
            {omskTime}
          </span>
        </div>
        
        <div className="flex items-center justify-center gap-2">
          <div className={`w-2 h-2 rounded-full ${working ? 'bg-primary' : 'bg-muted'} ${working ? 'animate-pulse' : ''}`}></div>
          <span className={`text-sm font-mono ${working ? 'text-primary' : 'text-muted-foreground'}`}>
            {working ? 'Сейчас на связи' : 'Вне рабочих часов'}
          </span>
        </div>

        <div className="grid grid-cols-7 gap-1 pt-2">
          {['Пн', 'Вт', 'Ср', 'Чт', 'Пт', 'Сб', 'Вс'].map((day, index) => {
            const currentDay = time.getDay();
            const adjustedDay = currentDay === 0 ? 6 : currentDay - 1;
            const isToday = adjustedDay === index;
            
            return (
              <div
                key={day}
                className={`text-xs font-mono p-1 rounded ${
                  isToday
                    ? 'bg-primary/20 text-primary border border-primary/40'
                    : 'text-muted-foreground'
                }`}
              >
                {day}
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default LiveClock;
